define(function (require) {

    var App = window.App || {};
    var BaseEngagementWidget = require('web-agent-widgets/BaseEngagementWidget');

    var VisitorListEngagementWidget = BaseEngagementWidget.extend({
        ControllerName: "VisitorListEngagementWidget",
        applicationType: "VisitorListEngagementWidget",

        LPViewMap: {
        },

        initialize: function (constructorData) {
        },

        events: function () {
            this.viewEventsHandler.bindEvent({appName : this.tableName, UIEvent : this.eventType.TABLE_WIDGETS_CLOSED, callback: this.stopSpectate, context: this});
        },

        render: function () {
        }
    });

    VisitorListEngagementWidget.prototype.onSelectedEngagementChanged = function (data) {
        BaseEngagementWidget.prototype.onSelectedEngagementChanged.call(this, data);
        var engagementData = data.newValue.eventData;
        if (engagementData && engagementData[this.itemIdTag]) {
            if (this.engagementId) {
                this.stopSpectate();
            }
            if (lpTag.WebAgent.logicController.visitorHasChat(engagementData) &&
                lpTag.WebAgent.logicController.agentCanViewChat(engagementData)) {
                this.engagementId = engagementData[this.itemIdTag];
                this.startSpectate();
                this.engagementVC.updateChatId(this.engagementId);
            }
        }
    };

    VisitorListEngagementWidget.prototype.stopSpectate = function () {
        if (this.engagementId && !lpTag.WebAgent.logicController.isInMyEngagements(this.engagementId)) {
            this.modelController.stopSpectate({chatId: this.engagementId});
        }
        this.engagementId = null;
    };

    VisitorListEngagementWidget.prototype.startSpectate = function () {
        var that = this;
        if (this.engagementId) {
            if (lpTag.WebAgent.logicController.isInMyEngagements(this.engagementId)) {
                this.engagementVC.removeErrorState(); // in case it is in my engagements there is no loading or error indication needed since the chat lines are already in the model.
            } else {
                this.engagementVC.setLoading(); // in this case we do want to set a loading and invoke the server request for the chat data
                this.modelController.startSpectate({
                    chatId: this.engagementId,
                    success: function () {
                        that.engagementVC.removeLoading();
                    },
                    error: function () {
                        that.engagementVC.setErrorState();
                    }
                });
            }
        }
    };

    return VisitorListEngagementWidget;

});
